import {
  MiddlewareAPI,
  isRejectedWithValue,
  Middleware,
} from "@reduxjs/toolkit";
// import { updateErrorMessage } from '../../features/Global/slice';

const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) =>
  (next) =>
  (action): any => {
    if (isRejectedWithValue(action)) {
      console.log("=-=-=-=", action.error);
      // if (action.payload.data && action.payload.data.errors && action.payload.status !== 429) {
      //   api.dispatch(
      //     updateErrorMessage({
      //       type: 'error',
      //       messages: action.payload.data.errors
      //     })
      //   );
      // } else if (action.payload.data && action.payload.messages) {
      //   api.dispatch(
      //     updateErrorMessage({
      //       type: 'error',
      //       messages: action.payload.messages
      //     })
      //   );
      // }
    }
    return next(action);
  };

const successMessageLogger =
  (api: {
    dispatch: (arg0: { payload: any | undefined; type: string }) => void;
  }) =>
  (next: (arg0: any) => any) =>
  // (action: {
  //   meta: {
  //     arg: {
  //       endpointName: string;
  //       originalArgs: { section: any; action: any };
  //     };
  //     requestStatus: string;
  //     baseQueryMeta: { response: { status: number } } | undefined;
  //   };
  //   payload: {
  //     length: number;
  //     map: (arg0: (p: any) => false | void) => void;
  //     status: string;
  //     messages: string;
  //   };
  // }): any => {
  (action: any): any => {
    return next(action);
  };

export { rtkQueryErrorLogger, successMessageLogger };
